<template>
    <div class="min-h-75vh w-100">
        <Stepper
            ref="formStepper"
            :steps="stepNames"
            id="formStepper"
            :handle-finish="registerData"
            :eventName="eventName"
            :processing="processing"
            :note="note"
            :show-nav="showNav"
        >
          <template v-for="(step, index) in steps" :key="index" v-slot:[`step${index+1}`]>
            <Card v-if="!step.repeatable">
                <p class="fs-4 fs-bolder mb-5"> {{ step.description }} </p>
                <RequiredText />
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6" v-for="(field, index) in step.fields" :key="index">
                        <FormField
                            :key="step.id + field.id"
                            :form-data="field"
                            :form-errors="formErrors"
                            :parentId="parentId"
                            v-model="formData" />
                    </div>
                </div>

            </Card>
            <Card v-else>
                <p class="fs-4 fs-bolder mb-5"> {{ step.description }} </p>
                <div class="row">
                    <div class="col-12">
                        <Repeatable
                            :step="step.id"
                            :fields="step.fields"
                            :title="step?.name"
                            v-model="formData[step.id]"
                        />
                    </div>
                </div>
            </Card>
          </template>
        </Stepper>
    </div>
</template>
<script setup>
import Card from '@/components/Card.vue';
import FormField from '@/components/Form/FormField.vue';
import Repeatable from './Repeatable.vue';
import { Stepper } from './Stepper';
import { ref, reactive, computed } from 'vue';
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"

const emits = defineEmits(["close"]);

const store = useStore()

const props = defineProps({
    steps:{type: Array, default: []},
    onSubmit: {type: Function, default: () => {}},
    eventName: {
        type: String,
        default: ''
    },
    note: {
        type: String, 
        default: ''
    },
    showNav: { 
         type: Boolean,
        default:  true
     },
    formId: {
        type: String,
        default: ''
    },
    parentId: {
        type: String,
        default: ''
    }
})

const formData = reactive({
    event_form_id: props.formId,
})
const formErrors = ref({})
const processing = ref(false)

const stepNames = computed(() => props.steps.map(el => el.name))

function registerData() {
    if(props.formId){
        processing.value = true
        formData.event_form_id = props.formId
        store
            .dispatch('forms/registerParticipator', formData)
            .then(() => {
                emits('close');
                window.toastr["success"](i18n.global.t('events.registered_successfully'));
            })
            .catch((e) => {
            }).finally(() => processing.value = false);
        }
    
}
</script>